import { useMemo, useState } from "react";
import VirtualizedTable from "../components/VirtualizeTable";
import CouponsDelete from "./CouponsDelete";
import CouponsDetails from "./CouponsDetails";
import { MRT_ColumnDef } from "material-react-table";
import { formatPrice } from "../helpers/format";
import { IconEdit, IconTrash } from "@tabler/icons-react";

const CouponsTableComponent = ({
  data,
  refetch,
}: {
  data: Array<{
    id: string;
    code: string;
    cuponsUser: number;
    limit: number;
    discount: number;
    discountType: string;
    validate: Date;
    type: string;
    firstMonthlyPayment: boolean;
    statusCupom: string;
  }>;
  refetch: () => void;
}) => {
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [edit, setEdit] = useState(false);
  const [value, setValue] = useState(data[0] || {});
  const [id, setId] = useState("");

  const columns = useMemo<MRT_ColumnDef<(typeof data)[0]>[]>(
    () => [
      {
        accessorKey: "code",
        header: "Código",
      },
      {
        accessorKey: "discount",
        header: "Desconto",
        Cell: ({ row }) =>
          row.original.discountType === "MONEY"
            ? formatPrice(row.original.discount)
            : `${row.original.discount}%`,
      },
      {
        accessorKey: "discountType",
        header: "Tipo",
        Cell: ({ cell }) =>
          cell.getValue<string>() === "MONEY" ? "Dinheiro" : "Porcentagem",
      },
      {
        accessorKey: "statusCupom",
        header: "Status",
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ cell }) => {
          const status = cell.getValue<string>();
          if (status === "AVAILABLE") return "Ativo";
          if (status === "EXPIRED") return "Expirado";
          if (status === "DELETED") return "Deletado";
          return status;
        },
      },
      {
        id: "edit",
        header: "Editar",
        size: 50,
        Cell: ({ row }: any) => (
          <IconEdit
            onClick={() => {
              setEdit(true);
              setValue(row.original);
            }}
            style={{ cursor: "pointer", color: "#FFF" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
      {
        id: "delete",
        header: "Excluir",
        size: 50,
        Cell: ({ row }: any) => (
          <IconTrash
            onClick={() => {
              setId(row.original.id);
              setDeleteAlert(true);
            }}
            style={{ cursor: "pointer", color: "#d32f2f" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
    ],
    [data]
  );

  return (
    <>
      <VirtualizedTable
        data={data}
        columns={columns}
        fetchNextPage={() => Promise.resolve()}
        isLoading={false}
      />

      <CouponsDelete
        open={deleteAlert}
        onClose={() => setDeleteAlert(false)}
        id={id}
        onAction={refetch}
      />

      <CouponsDetails
        open={edit}
        onClose={() => setEdit(false)}
        data={value}
        refetch={refetch}
      />
    </>
  );
};

export default CouponsTableComponent;
